// extracted by mini-css-extract-plugin
export default {"Column":"styles_Column__Z6Jge","drag":"styles_drag__uAoqQ","delete":"styles_delete__RSW8P","mandatory":"styles_mandatory__zYwMt"};